export default __webpack_public_path__ + "locales/pt/ResetApplicationDialog.json?hash=f0a7ac5569f92fbf82409aadb5345262";